module.exports = __webpack_public_path__ + "static/media/lineafabrica.1afe448c.png";